import React from 'react';
import { statusTextMap, statusFontColorMap } from './status/statusConfig';
import { cloneDeep } from 'lodash';

// 内容导航显示状态
// NEW 新建
// STAY_AUDIT 待审核
// ALREADY_AUDIT 已审核
// PUBLISHED 已发布
// MODIFIED 已修改
// OFFLINE 已下架
const contentItemState = (auditStatus: string) => {
  const _statusTextMap = cloneDeep(statusTextMap);
  _statusTextMap.NEW = '草稿';
  return (
    <span
      style={{
        float: 'right',
        fontSize: '10px',
        color: `${statusFontColorMap[auditStatus]}`,
      }}>
      · {_statusTextMap[auditStatus]}
    </span>
  );
};
export default contentItemState;
